function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { Fragment } from 'react';
import { withTheme } from 'styled-components';
import { finectAPI } from '@finect/front-utils/finectAPI';
import { Button } from '@finect/tabular-core/Button';
import { getProductReviewsPath } from '@finect/front-resources/Products';
import { getReviewPath } from '../utils';
import { Spinner } from '../../Spinner';
import { ratingToLabel, isTitleValid, isBodyValid, validateFields, getSubmitTooltip, getTitleHint, getBodyHint } from './utils';
import { Rating } from './../../Rating';
import { models } from './../utils/models';
import { ReviewCard } from './../ReviewCard';
import { getCatalogFeatures } from './actions';
import { Input, Textarea, Checkbox } from './../Forms';
import { Tooltip } from './../../Tooltip';
import { RatingLabel, Label, ReviewBlock, LegalDisclaimer } from './partials';
export var ReviewForm = function (_React$Component) {
  _inherits(ReviewForm, _React$Component);
  var _super = _createSuper(ReviewForm);
  function ReviewForm() {
    var _this;
    _classCallCheck(this, ReviewForm);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      product: _this.props.product,
      availableFeatures: [],
      title: '',
      body: '',
      score: 0,
      terms: false,
      features: {},
      valid: false,
      fetching: false,
      step: 'initial',
      model: null,
      titleStatus: 'initial',
      bodyStatus: 'initial'
    });
    _defineProperty(_assertThisInitialized(_this), "bodyEditor", void 0);
    _defineProperty(_assertThisInitialized(_this), "titleEditor", void 0);
    _defineProperty(_assertThisInitialized(_this), "handleRatingChange", function (score) {
      var _this$state = _this.state,
        title = _this$state.title,
        body = _this$state.body,
        terms = _this$state.terms;
      _this.setState({
        score: score,
        valid: validateFields(title, body, score, terms)
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleTitleReturn", function () {
      return false;
    });
    _defineProperty(_assertThisInitialized(_this), "handleTitleChange", function (title) {
      var _this$state2 = _this.state,
        body = _this$state2.body,
        score = _this$state2.score,
        terms = _this$state2.terms;
      _this.setState({
        title: title,
        valid: validateFields(title, body, score, terms),
        titleStatus: _this.state.titleStatus !== 'initial' ? isTitleValid(title) ? 'success' : 'error' : _this.state.titleStatus
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleBodyChange", function (body) {
      var _this$state3 = _this.state,
        title = _this$state3.title,
        score = _this$state3.score,
        terms = _this$state3.terms;
      _this.setState({
        body: body,
        valid: validateFields(title, body, score, terms),
        bodyStatus: _this.state.bodyStatus !== 'initial' ? isBodyValid(body) ? 'success' : 'error' : _this.state.bodyStatus
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleCheckboxChange", function (event) {
      var _this$state4 = _this.state,
        title = _this$state4.title,
        body = _this$state4.body,
        score = _this$state4.score;
      var terms = event.target.checked;
      _this.setState({
        terms: terms,
        valid: validateFields(title, body, score, terms)
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleClick", function () {
      _this.loginCreate();
    });
    _defineProperty(_assertThisInitialized(_this), "handleTitleBlur", function () {
      _this.setState({
        titleStatus: isTitleValid(_this.state.title) ? 'success' : 'error'
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleTitleFocus", function () {
      _this.setState({});
    });
    _defineProperty(_assertThisInitialized(_this), "handleBodyBlur", function () {
      _this.setState({
        bodyStatus: isBodyValid(_this.state.body) ? 'success' : 'error'
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleBodyFocus", function () {
      _this.setState({});
    });
    return _this;
  }
  _createClass(ReviewForm, [{
    key: "getPayload",
    value: function getPayload() {
      return {
        score: this.state.score,
        title: this.state.title,
        body: {
          metadata: {},
          text: this.state.body
        },
        features: Object.values(this.state.features).map(function (element) {
          return {
            alias: element.alias,
            score: element.score,
            body: element.body
          };
        })
      };
    }
  }, {
    key: "loginCreate",
    value: function loginCreate() {
      var _this2 = this;
      this.setState({
        fetching: true
      });
      var product = this.state.product;
      var theme = this.props.theme;
      var next = "https://".concat(process.env.FINECT_BASEURL || 'www.finect.com').concat(getProductReviewsPath(product));
      finectAPI({
        version: 'v4',
        path: "contents/products/".concat(product.entity.id, "/reviews"),
        method: 'POST',
        headers: {
          'x-referrer': next
        },
        body: this.getPayload(),
        onSuccess: function onSuccess(_ref) {
          var data = _ref.data,
            code = _ref.code;
          _this2.setState({
            fetching: false
          });
          if (code === 302) {
            window.location.replace(data.location);
          }
          if (code === 201) {
            var path = getReviewPath(theme, product, models.review(data.review, [data.author]));
            window.location.replace(path.superPartnerURL);
          }
        },
        onError: function onError(_ref2) {
          var data = _ref2.data;
          _this2.setState({
            fetching: false
          });
        }
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this3 = this;
      getCatalogFeatures().then(function (features) {
        _this3.setState({
          availableFeatures: features
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var product = this.props.product;
      var titleErrors = isTitleValid(this.state.title) ? [] : ['El título no es válido'];
      var submitTooltip = getSubmitTooltip(this.state.title, this.state.body, this.state.score);
      if (this.state.step === 'published') {
        return React.createElement(ReviewCard, {
          product: product,
          me: this.props.user,
          collapsed: false,
          review: this.state.model,
          tag: this.props.tag
        });
      }
      return React.createElement(Fragment, null, React.createElement(ReviewBlock, null, React.createElement(Label, null, "Puntuaci\xF3n general"), React.createElement(Tooltip, {
        tip: "Pulsa una estrella para valorar",
        show: this.state.score === 0 && false,
        disabled: true || this.state.score > 0,
        from: "left",
        width: '320px'
      }, React.createElement(Rating, {
        starColorHover: '#FFD552',
        starColor: '#FFD552',
        starSize: '29px',
        isSelectable: true,
        value: this.state.score,
        onChange: this.handleRatingChange
      })), React.createElement(RatingLabel, null, ratingToLabel(this.state.score))), React.createElement(ReviewBlock, null, React.createElement(Input, {
        label: "T\xEDtulo de tu review",
        bordered: true,
        name: "review-title",
        placeholder: "Resume lo m\xE1s importante de ".concat(product.entity.name, " o destaca alg\xFAn detalle interesante"),
        onChange: this.handleTitleChange,
        onBlur: this.handleTitleBlur,
        onFocus: this.handleTitleFocus,
        status: this.state.titleStatus,
        errors: titleErrors,
        hint: getTitleHint(this.state.title)
      })), React.createElement(ReviewBlock, null, React.createElement(Textarea, {
        label: "Tu opini\xF3n",
        bordered: true,
        name: "review-body",
        handleChange: this.handleBodyChange,
        placeholder: "Cuenta tu experiencia con ".concat(product.entity.name, " para ayudar al resto de usuarios a tomar mejores decisiones financieras"),
        onChange: this.handleBodyChange,
        onBlur: this.handleBodyBlur,
        onFocus: this.handleBodyFocus,
        status: this.state.bodyStatus,
        hint: getBodyHint(this.state.body)
      })), React.createElement(ReviewBlock, null, React.createElement(Label, null, "Aceptaci\xF3n de condiciones"), React.createElement(Checkbox, {
        id: "terms",
        name: "terms",
        value: "accept",
        handleChange: this.handleCheckboxChange,
        required: true
      }, React.createElement(LegalDisclaimer, null, "Certifico que esta opini\xF3n est\xE1 basada en mi propia experiencia, que refleja mi opini\xF3n sincera sobre este producto, que no tengo ninguna relaci\xF3n, ya sea personal o empresarial, con el mismo y que adem\xE1s no me ha ofrecido incentivo o pago alguno por escribirla. Del mismo modo, entiendo que Finect aplica un sistema de moderaci\xF3n sobre los comentarios"))), React.createElement(Tooltip, {
        tip: submitTooltip,
        disabled: !submitTooltip
      }, React.createElement(Button, {
        secondary: true,
        onClick: this.handleClick,
        width: 'auto',
        disabled: !this.state.valid || this.state.fetching
      }, "Publicar opini\xF3n"), this.state.fetching ? React.createElement(Spinner, null) : null));
    }
  }]);
  return ReviewForm;
}(React.Component);
export default React.memo(withTheme(ReviewForm));